import { FormWithRedux } from '../../FormWithRedux';
import { EDChestPainRedFlagsDifferentialDiagnosesForm } from './EDChestPain-RedFlagsDifferentialDiagnosesForm';
import { EDChestPainRedFlagsFindingsForm } from './EDChestPain-RedFlagsFindingsForm';
import { CalculationModel } from '../Custom Types/Calculation';
import { RiskCategoryBrackets } from '../Custom Types/Risk Category';
import { redux } from '../../../components/App';
import { saveCalculation } from '../../../components/state/actions/CalculationActions';
import { FormsStyles } from '../../../waferJS/FormsUI/FormsUI';
import { EDChestPainCalculationHelper } from '../Helpers/EDChestPainCalculationHelper';
import { saveAction } from '../../../components/state/actions/ActionActions';
import { EDChestPainProbabilityOfMACEGraphForm } from './EDChestPain-ProbabilityOfMACEGraphForm';
import { PathwayReferenceHelper } from '../../PathwayReferenceHelper';
import { FormLoader } from '../../FormLoader';
import { getPathwayIdFromURL } from '../../../helpers/URLHelper';

export class EDChestPainResultsForm extends FormWithRedux {

    set calculations(value) {
        this._calculations= JSON.parse(JSON.stringify(value));
    }

    get calculations() {
        return this._calculations;
    }

    set actions(value) {
        this._actions = JSON.parse(JSON.stringify(value));
    }

    get actions() {
        return this._actions;
    }

    constructor(parent, actionsUpdater, dependenValuesUpdater, calculationsUpdater) {
        super('resultsForm', parent, actionsUpdater, dependenValuesUpdater, calculationsUpdater);

        let self = this;
        redux.store.subscribe(() => {
            let state = redux.store.getState();
            self.calculations = state.calculationReducer.calculations;
            self.actions = redux.store.getState().actionsReducer.actions;
        });

        this.calculations = redux.store.getState().calculationReducer.calculations;

        this.actions = redux.store.getState().actionsReducer.actions;
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'highRiskDifferentialDiagnosisRedFlagsForm':
                return new EDChestPainRedFlagsDifferentialDiagnosesForm(this.parent, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'highRiskFindingsRedFlagsForm':
                return new EDChestPainRedFlagsFindingsForm(this.parent, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'probabilityOfMACEGraphForm':
                return new EDChestPainProbabilityOfMACEGraphForm();
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        let formDetail = this.formDetail(identifier);
        if(formDetail.controlType == 'action'){
            if(this.actions[this.pathwayId] != null){
                let pathwayActions = this.actions[this.pathwayId];
                if(pathwayActions == null || JSON.stringify(pathwayActions) == JSON.stringify({})){
                    return null;
                }
                return pathwayActions.filter((action) => {return action.identifier == identifier;}).length > 0;
            }
            return false;
        } else if(identifier == 'probabilityOfMACEGraphForm'){
            return this.getValue('probabilityOfMACE') != null;
        }

        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    getBadgeValue(identifier) {
        if(identifier == 'calculatedEDACS'){
            let calculation = EDChestPainCalculationHelper.getLatestCalculation(CalculationModel.CalculationType.edacs, this.calculations[this.pathwayId]);
            
            if(calculation != null){
                return [{
                    color: calculation.badgeColor,
                    value: calculation.valueString,
                    solid: calculation.badgeStyle
                }];
            }
        } else if(identifier == 'probabilityOfMACE'){
            let calculation = EDChestPainCalculationHelper.getLatestCalculation(CalculationModel.CalculationType.probabilityOfMace, this.calculations[this.pathwayId]);
            if(calculation != null){
                return [{
                    color: calculation.badgeColor,
                    value: calculation.valueString,
                    solid: calculation.badgeStyle
                }];
            }
        } else if(identifier == 'pathwayRiskCategory'){
            let calculation = EDChestPainCalculationHelper.getLatestCalculation(CalculationModel.CalculationType.riskCategory, this.calculations[this.pathwayId]);
            if(calculation != null){
                if (calculation.value != null) {
                    let riskBracket = new RiskCategoryBrackets(calculation.value);
                    if(riskBracket != null){
                        return [{
                            color: riskBracket.riskCategory.color,
                            value: riskBracket.riskCategory.title != null ? riskBracket.riskCategory.title : 'N/A',
                            solid: true
                        }];
                    } 
                }
            }
            return[{
                color: FormsStyles.black,
                value: null,
                solid: false
            }];
        } else if(identifier == 'highRiskDifferentialDiagnosisRedFlagsForm'){
            let dependentValues = [
                'aorticDissectionPresentRedFlag',
                'pulmonaryEmbolismRedFlag',
                'pancreatitisRedFlag',
                'oesophagealRuptureRedFlag',
                'pneumothoraxRedFlag',
            ];
            let values = dependentValues.map((identifier) => {
                if (this.getValue(identifier + 'Override') == true) {
                    return this.getValue(identifier + 'OverrideValue') == true ? true : null;
                } else {
                    return this.getValue(identifier) == true ? true : null;
                }
            });
            let total = values.filter(n => n).length;
            if (total > 0){
                return[{
                    color: FormsStyles.red,
                    value: total.toString() + ' RED FLAG' + (total == 1 ? '' : 'S'),
                    solid: true
                }];
            }
        } else if(identifier == 'highRiskFindingsRedFlagsForm'){
            let dependentValues = [
                'redFlagsOngoingChestPain',
                'crescendoAngina',
                'haemodynamicInstability',
                'newIschaemicChanges' 
            ];
            let values = dependentValues.map((identifier) => {
                if (this.getValue(identifier + 'Override') == true) {
                    return this.getValue(identifier + 'OverrideValue') == true ? true : null;
                } else {
                    return this.getValue(identifier) == true ? true : null;
                }
            });
            let total = values.filter(n => n).length;
            if (total > 0){
                return[{
                    color: FormsStyles.red,
                    value: total.toString() + ' RED FLAG' + (total == 1 ? '' : 'S'),
                    solid: true
                }];
            }
        } else if(identifier == 'resultsForm'){

            let probabilityOfMace = EDChestPainCalculationHelper.getLatestCalculation(CalculationModel.CalculationType.probabilityOfMace, this.calculations[this.pathwayId]);
            let riskCategory = EDChestPainCalculationHelper.getLatestCalculation(CalculationModel.CalculationType.riskCategory, this.calculations[this.pathwayId]);
            let edacs = EDChestPainCalculationHelper.getLatestCalculation(CalculationModel.CalculationType.edacs, this.calculations[this.pathwayId]);
            let calculations = [probabilityOfMace, riskCategory, edacs].filter(n => n);

            return EDChestPainCalculationHelper.getHighestPriorityCalculationBadges(calculations);
        }
        return [];
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return 'summary';
    }

    calculationError(identifier){
        let data = null;
        if(this.workflow[this.pathwayId] != null){
            data = this.workflow[this.pathwayId].rawData;
        }
        return EDChestPainCalculationHelper.calcualtionError(identifier, data, this);
    }

    latestCalculation(identifier){
        return EDChestPainCalculationHelper.getLatestCalculation(this.getTypeFromIdentifier(identifier), this.calculations[this.pathwayId]);
    }

    previousCalculation(identifier){
        return EDChestPainCalculationHelper.getPreviousCalculation(this.getTypeFromIdentifier(identifier), this.calculations[this.pathwayId]);
    }

    markCalculationAsObserved(identifier){
        let calculation = this.latestCalculation(identifier);
        if(calculation != null){
            calculation.observed = true;
            redux.store.dispatch(saveCalculation(getPathwayIdFromURL(), calculation, this.calculations));
        }
    }

    markActionAsObserved(identifier){
        if(this.actions[this.pathwayId] == null ){ return; }
        let matchingActions = this.actions[this.pathwayId].filter((action) => {
            return action.identifier == identifier;
        });

        let filteredActions = this.actions[this.pathwayId].filter((action) => {
            return action.identifier != identifier;
        });

        if (matchingActions.length == 0 ) { return;}

        let action = matchingActions[0];

        if(!action.removeAfterObservation){
            action.observed = true;
            filteredActions.push(action);
        }

        redux.store.dispatch(saveAction(this.pathwayId, filteredActions));
    }

    calculationProgress(identifier){
        if(CalculationModel.typeRequiresPrimaryFormValidation(this.getTypeFromIdentifier(identifier))){
            let form = FormLoader.form(this.pathwayId, 'mainForm');
            let progress = form.completionProgress(['followUpBloodsDateAndTime', 'followUpBloodsTroponin']);
            if(progress != null){
                return (progress.current / progress.total);
            }
            return 0;
        } else if(identifier == 'calculatedEDACS'){
            let requiredIdentifiers = [
                'coronaryHeartDisease', 'coronaryArteryStenosis',
                'prematureCoronaryHeartDisease', 'diabetes', 'hypertension', 'dyslipidaemia', 'currentSmoker',
                'diaphoresis', 'pleuriticPain', 'painRadiates', 'painByPalpation', 'patientAge', 'patientSex'
            ];

            let missingCount = requiredIdentifiers.map((identifier) => {
                return this.getValue(identifier) != null ? true : null;
            }).filter(n => n).length;
            return (missingCount / requiredIdentifiers.length);
        }
        return 1;
    }

    getTypeFromIdentifier(identifier){
        if(identifier == 'calculatedEDACS'){
            return CalculationModel.CalculationType.edacs;
        } else if(identifier == 'probabilityOfMACE'){
            return CalculationModel.CalculationType.probabilityOfMace;
        } else if(identifier == 'pathwayRiskCategory'){
            return CalculationModel.CalculationType.riskCategory;
        }
    }

    actionForIdentifier(identifier){
        if(this.actions[this.pathwayId] != null ){
            let filteredAction = this.actions[this.pathwayId].filter((action) => {return action.identifier == identifier;});
            if(filteredAction.length > 0){
                return filteredAction[0];
            }
        }
        
        return null;
    }

    getPlainTextActions(){
        let sectionStrings = this.sectionIds.map((sectionID) => {
            let section = this.sectionReference(sectionID);
            var sectionString = '';
            
            let sectionValues = [];
            if(section[PathwayReferenceHelper.Type.sectionChildIDs] != undefined){
                section[PathwayReferenceHelper.Type.sectionChildIDs].map((childID) => {
                    let formDetail = this.formDetail(childID);
                    if(formDetail.controlType == 'action'){
                        let action = this.actionForIdentifier(formDetail.identifier);
                        if(action != null){
                            let actionStringComponents = [];
                            action.title != null ? actionStringComponents.push(this.stripSpecialChars(action.title)) : actionStringComponents.push(this.stripSpecialChars(formDetail.title));
                            action.detail != null ? actionStringComponents.push(this.stripSpecialChars(action.detail)) : actionStringComponents.push(this.stripSpecialChars(formDetail.detail));
                            sectionValues.push(actionStringComponents.filter(n => n).join('\n'));
                        }
                    }
                });

                if(sectionValues.length > 0){
                    if(section.title != null){
                        sectionString += section.title.toUpperCase() + '\n';
                    }
                    sectionString += sectionValues.join('\n');
                }
            }
            return sectionString == '' ? null : sectionString;
        }).filter( n => n);

        return sectionStrings.join('\n\n');
    }

    stripSpecialChars(string){
        if (string != null) {
            if(!string.includes('#@')){ return string; } 
            let components = string.split('#@');
            let strippedString = '';
            for(let component of components){
                if(component.includes('^')){
                    let subComponents = component.split('^');
                    strippedString += subComponents[1];
                } else {
                    strippedString += component;
                }
            }
            return strippedString;
        }
    }
}


// WEBPACK FOOTER //
// ./src/forms/edChestPain01/Forms/EDChestPain-ResultsForm.js